import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "GlobalComparatorCta" })
export default class GlobalComparatorCta extends Vue {
    public localizer: any = Localizer;

    @Prop() readonly catalogue: string;
    @Prop() readonly bremboCode: string;
    @Prop() readonly productType: string;
    @Prop() readonly productSubType: string;

    get comparatorProducts() {
        return this.$store.getters["globalComparatorStore/comparatorProducts"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public isActive(): boolean {
        return this.comparatorProducts.some(x => x.bremboCode === this.bremboCode);
    }

    public async toggleAddEntry() {
        if (this.isActive()) {
            await this.$store.dispatch("globalComparatorStore/removeEntry", { bremboCode: this.bremboCode });
        } else {
            await this.$store.dispatch("globalComparatorStore/addEntry", { catalogue: this.catalogue, bremboCode: this.bremboCode, productType: this.productType, productSubType: this.productSubType });
            GTagHelper.sendEvent("click", "comparator_add");
        }
    }
}